<mat-progress-bar *ngIf="isSearching" mode="indeterminate"></mat-progress-bar>
<div class="converters background-white">
  <div class="filter-and-add">
    <div class="converter-filter">
      <mat-form-field [hideRequiredMarker]="true" style="height: 48px; width: 280px" appearance="outline"
        [ngClass]="{ 'small-placeholder': isInputFocused }">
        <mat-label>Search by converter name</mat-label>
        <input matInput #input [(ngModel)]="searchTemplateInput" (focus)="isInputFocused = true"
          (blur)="isInputFocused = false" (keyup)="filterConverters(input.value)" (input)="toggleIcon()" />
        <mat-icon style="cursor: pointer; margin-top: 5px" *ngIf="showClearIcon" matSuffix
          (click)="clearSearch()">close</mat-icon>
        <mat-icon matSuffix *ngIf="!showClearIcon && !isInputFocused">search</mat-icon>
      </mat-form-field>
    </div>
  </div>

  <ng-container *ngIf="!isLoading && items?.length">
    <div class="scrollable-container" #scrollableContainer style="padding-bottom: 16px;">
      <table class="si-table">
        <thead>
          <tr>
            <th>
              <div class="header-content">
                <span class="roboto">Converter Name</span>
              </div>
            </th>
            <th>
              <span class="roboto">Action</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="show-on-hover cursor-pointer" *ngFor="let item of items; let i = index"
            (click)="openConverter(item, $event)">
            <td class="sorted">
              <div class="item-name">
                {{ item.name }}
              </div>
            </td>
            <td class="action-cell">
              <button mat-button class="view-button" [class.disabled]="item.status !== 1" [disabled]="item.status !== 1"
                (click)="openConverter(item, $event); $event.stopPropagation()">
                View
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

  <ng-container *ngIf="!isLoading && !items?.length && !isSearching">
    <div class="no-data-wrapper">
      <img [style.width]="!items?.length && !isSearching ? '139px' : '200px'" height="225px" [src]="
          !items?.length && !isSearching
            ? '/assets/icons/printer.svg'
            : '/assets/icons/empty-search.svg'
        " />
      <p class="no-data-title">No converters found</p>
      <p *ngIf="!items?.length && !isSearching">
        No converters available at the moment.
      </p>
      <p *ngIf="!items?.length && isSearching">
        We are sorry, we couldn't find any matching results. Please try different search.
      </p>
    </div>
  </ng-container>

  <ng-container *ngIf="isLoading">
    <table style="margin-top: 10px" class="si-table">
      <tbody>
        <tr *ngFor="let number of [1, 2, 3]">
          <td>
            <ngx-skeleton-loader count="1" appearance="line" [theme]="{
                height: '15px',
                width: '150px',
                'border-radius': '3px'
              }">
            </ngx-skeleton-loader>
          </td>
          <td>
            <ngx-skeleton-loader count="1" appearance="line"
              [theme]="{ height: '15px', width: '80px', 'border-radius': '3px' }">
            </ngx-skeleton-loader>
          </td>
        </tr>
      </tbody>
    </table>
  </ng-container>
</div>